import { render } from "./BrandPortfolioTrendingCell.vue?vue&type=template&id=b0697702&scoped=true"
import script from "./BrandPortfolioTrendingCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioTrendingCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioTrendingCell.vue?vue&type=style&index=0&id=b0697702&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0697702"]])

export default __exports__